(function () {
  'use strict';

  angular.module('sempraWebapp').factory('DeviceStateEnum', deviceStateEnumFactory);

  function deviceStateEnumFactory () {
    return Object.freeze({
      CONNECTED: 'CONNECTED',
      OFFLINE: 'OFFLINE',
      DEACTIVATED: 'DEACTIVATED'
    });
  }
})();
